<template>
  <div class="hm-dates">
    <div class="hm-dates__item">
      <div class="hm-dates__title">{{ titleFirst }}</div>
      <div class="hm-dates__date">
        <div class="hm-dates__icon">
          <img src="@/assets/img/hm/calendar.svg" alt="">
        </div>
        {{ dateFormat(dateFirst) }}
      </div>
    </div>
    <img v-if="dateSecond" src="@/assets/img/hm/arrow-right-grey.svg" alt="" class="hm-dates__arrow">
    <div v-if="dateSecond" class="hm-dates__item">
      <div class="hm-dates__title">{{ titleSecond }}</div>
      <div class="hm-dates__date">
        <div class="hm-dates__icon">
          <img src="@/assets/img/hm/calendar.svg" alt="">
        </div>
        {{ dateFormat(dateSecond) }}
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'HMDates',
  props: {
    dateFirst: { type: String, required: true },
    dateSecond: { type: String, default: '' },
    titleFirst: { type: String, required: true },
    titleSecond: { type: String, default: '' }
  },
  methods: {
    dateFormat(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMM')
    }
  }
}
</script>

<style scoped>
.hm-dates {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  max-width: max-content;
}

.hm-dates__arrow {
  display: inline-block;
  transform: translateY(-4px);
}

.hm-dates__title {
  margin-bottom: 10px;
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}

.hm-dates__date {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>